var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5747 10V10C21.3619 10 22 10.6381 22 11.4253V12.5747C22 13.3619 21.3619 14 20.5747 14V14C19.9523 14.0012 19.3924 14.3786 19.1577 14.9551L19.15 14.9739C18.9093 15.547 19.0387 16.2088 19.4775 16.649V16.649C20.0341 17.2056 20.0341 18.1081 19.4775 18.6647L18.6647 19.4775C18.1081 20.0341 17.2057 20.0341 16.6491 19.4775V19.4775C16.2088 19.0386 15.5471 18.9092 14.974 19.1499L14.9551 19.1577C14.3786 19.3923 14.0012 19.9523 14 20.5747V20.5747C14 21.3619 13.3619 22 12.5747 22H11.4253C10.6381 22 10 21.3619 10 20.5747V20.5747C9.99882 19.9523 9.62141 19.3924 9.0449 19.1577L9.0261 19.15C8.45297 18.9093 7.79122 19.0387 7.35097 19.4775V19.4775C6.79436 20.0341 5.89194 20.0341 5.33533 19.4775L4.52254 18.6647C3.96594 18.1081 3.96594 17.2057 4.52254 16.6491V16.6491C4.96138 16.2088 5.09078 15.5471 4.85009 14.974L4.84233 14.9552C4.6077 14.3786 4.04774 14.0012 3.42528 14V14C2.63812 14 2 13.3619 2 12.5747V11.4253C2 10.6381 2.63812 10 3.42528 10V10C4.04771 9.99882 4.60764 9.62141 4.84228 9.0449L4.85004 9.0261C5.09073 8.45299 4.96135 7.79126 4.52254 7.351V7.351C3.96594 6.79439 3.96594 5.89197 4.52254 5.33536L5.33533 4.52257C5.89194 3.96597 6.79436 3.96597 7.35097 4.52257V4.52257C7.79122 4.96141 8.45297 5.09081 9.0261 4.85012L9.0449 4.84236C9.62144 4.60771 9.99885 4.04774 10 3.42528V3.42528C10 2.63812 10.6381 2 11.4253 2H12.5747C13.3619 2 14 2.63812 14 3.42528V3.42528C14.0012 4.04771 14.3786 4.60764 14.9551 4.84228L14.9739 4.85004C15.547 5.09073 16.2087 4.96135 16.649 4.52254V4.52254C17.2056 3.96594 18.108 3.96594 18.6646 4.52254L19.4774 5.33533C20.034 5.89194 20.034 6.79436 19.4774 7.35097V7.35097C19.0386 7.79122 18.9092 8.45297 19.1499 9.0261L19.1576 9.0449C19.3923 9.62144 19.9523 9.99885 20.5747 10Z",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e153fe67db3a63b7b8d9643f9c142d44.svg";
export { ForwardRef as ReactComponent };